import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

export const Reveal = ({ children, delay = 0, y = 28, x = 0, className = "" }) => (
  <motion.div
    className={`will-change-transform ${className}`}
    initial={{ opacity: 0, y, x }}
    whileInView={{ opacity: 1, y: 0, x: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1.05, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Word-by-word masked rise — for display headlines.
export const Words = ({ text, className = "", delay = 0 }) => (
  <span className={className} aria-label={text}>
    {text.split(" ").map((w, i, arr) => (
      <span key={i} aria-hidden className="inline-block overflow-hidden align-bottom">
        <motion.span
          className="inline-block will-change-transform"
          initial={{ y: "110%" }}
          whileInView={{ y: "0%" }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, delay: delay + i * 0.055, ease: EASE }}
        >
          {w}
          {i < arr.length - 1 ? "\u00A0" : ""}
        </motion.span>
      </span>
    ))}
  </span>
);

export const SectionHead = ({ eyebrow, title, sub }) => (
  <div className="mx-auto mb-14 max-w-3xl text-center">
    <Reveal>
      <span className="font-mono text-[11px] uppercase tracking-[0.4em] text-gold sm:text-xs">{eyebrow}</span>
    </Reveal>
    <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-fg sm:text-3xl lg:text-4xl" data-testid="section-title">
      <Words text={title} delay={0.1} />
    </h2>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-4 leading-relaxed text-soft">{sub}</p>
      </Reveal>
    )}
  </div>
);
